/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MailBankVerifyUserRequest
 */
export interface MailBankVerifyUserRequest {
    /**
     * 
     * @type {string}
     * @memberof MailBankVerifyUserRequest
     */
    realm?: string;
    /**
     * 
     * @type {string}
     * @memberof MailBankVerifyUserRequest
     */
    userId?: string;
}

/**
 * Check if a given object implements the MailBankVerifyUserRequest interface.
 */
export function instanceOfMailBankVerifyUserRequest(value: object): value is MailBankVerifyUserRequest {
    return true;
}

export function MailBankVerifyUserRequestFromJSON(json: any): MailBankVerifyUserRequest {
    return MailBankVerifyUserRequestFromJSONTyped(json, false);
}

export function MailBankVerifyUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailBankVerifyUserRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'realm': json['realm'] == null ? undefined : json['realm'],
        'userId': json['userId'] == null ? undefined : json['userId'],
    };
}

export function MailBankVerifyUserRequestToJSON(json: any): MailBankVerifyUserRequest {
    return MailBankVerifyUserRequestToJSONTyped(json, false);
}

export function MailBankVerifyUserRequestToJSONTyped(value?: MailBankVerifyUserRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'realm': value['realm'],
        'userId': value['userId'],
    };
}

